import { render, staticRenderFns } from "./BookingSuccess.vue?vue&type=template&id=06c20b83&scoped=true"
import script from "./BookingSuccess.vue?vue&type=script&lang=ts"
export * from "./BookingSuccess.vue?vue&type=script&lang=ts"
import style0 from "./BookingSuccess.vue?vue&type=style&index=0&id=06c20b83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c20b83",
  null
  
)

export default component.exports